/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Badge,
  BeekLogo,
  Breadcrumbs,
  Checkbox,
  Divider,
  Icon,
  Image,
  Link,
  List,
  Typography,
} from 'beek-design-system';
import { ReactNode } from 'react';

type MDXHTMLElementProps = {
  children: string | Element | ReactNode | ReactNode[] | any;
  src: string;
  alt: string;
  href: string;
};

const MarkDownComponents: any = {
  Badge,
  BeekLogo,
  Breadcrumbs,
  Checkbox,
  Icon,
  h1: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    if (typeof children === 'string') {
      return <Typography type="headline1">{children}</Typography>;
    }
    return [];
  },
  h2: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    if (typeof children === 'string') {
      return <Typography type="headline2">{children}</Typography>;
    }
    return [];
  },
  h3: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    if (typeof children === 'string') {
      return <Typography type="headline3">{children}</Typography>;
    }
    return [];
  },
  h4: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    if (typeof children === 'string') {
      return <Typography type="headline4">{children}</Typography>;
    }
    return [];
  },
  p: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    if (typeof children === 'string') {
      return (
        <Typography tag="p" type="body1">
          {children}
        </Typography>
      );
    }
    return [];
  },
  em: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    if (typeof children === 'string') {
      return (
        <Typography type="emphasis" display="inline">
          {children}
        </Typography>
      );
    }
    return [];
  },
  strong: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    if (typeof children === 'string') {
      return (
        <Typography type="strong" display="inline">
          {children}
        </Typography>
      );
    }
    return [];
  },
  del: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    if (typeof children === 'string') {
      return (
        <Typography type="delete" display="inline">
          {children}
        </Typography>
      );
    }
    return [];
  },
  hr: (): JSX.Element | JSX.Element[] => <Divider />,
  a: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children, href } = props;
    if (typeof children === 'string') {
      return (
        <Link href={href} display="inline">
          {children}
        </Link>
      );
    }
    return [];
  },
  img: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { src, alt } = props;
    return <Image url={src} alt={alt} />;
  },
  ul: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    const list = children?.map(
      (element: { props: { children: string } }) => element.props.children
    );
    return <List type="ul" elements={list} />;
  },
  ol: (props: MDXHTMLElementProps): JSX.Element | JSX.Element[] => {
    const { children } = props;
    const list = children?.map(
      (element: { props: { children: string } }) => element.props.children
    );
    return <List type="ol" elements={list} />;
  },
};

export default MarkDownComponents;
